/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["iframe[_ngcontent-%COMP%] {\n  width: 100%;\n  height: 500px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/social-media-monitor/social-media-monitor.component.scss.shim.ngstyle.js.pre-build-optimizer.js